import { useContext, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Stack,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import moment from "moment";
import { useMutation } from "@apollo/client";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
//Import from project
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { DialogTitleComp } from "../../../Utils/Component";
import {
  currencyFormat,
  generateInvoiceNumber,
} from "../../../Function/DynamicFn";
import ViewItemList from "./ViewItemList";
import EmptyData from "../../Include/EmptyData/EmptyData";
import { VOID_PAYMENT, UPDATE_ALERT_PAYMENT } from "../../../Schema/Invoice";
import useWithDimension from "../../../Hooks/useWithDimension";
import useGetAlertToPayByInvoiceId from "../../../Hooks/useGetAlertToPayByInvoiceId";
import VoidPayment from "../Void/VoidPayment";
import AlertList from "../Form/AlertList";

export default function ViewInvoice({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  const { t, language, setAlert } = useContext(AuthContext);
  const { width } = useWithDimension();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("invoice");
  const [paymentId, setPaymentId] = useState("");
  // console.log("paymentId::", paymentId);

  const { alertData, refetch } = useGetAlertToPayByInvoiceId({
    invoiceId: editData?._id,
  });

  // console.log("alertData::", alertData);

  const [alertItemData, setAlertItemData] = useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [openVoid, setOpenVoid] = useState(false);
  const handleOpenVoid = (id) => {
    setPaymentId(id);
    setOpenVoid(true);
  };
  const handleCloseVoid = () => setOpenVoid(false);

  const [voidPayment] = useMutation(VOID_PAYMENT, {
    onCompleted: ({ voidPayment }) => {
      // console.log("voidPayment :", voidPayment);
      setLoading(false);
      if (voidPayment?.isSuccess === true) {
        setAlert(true, "success", voidPayment?.message);
        handleCloseVoid();
        setRefetch();
        setPaymentId("");
      } else {
        setAlert(true, "error", voidPayment?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const [updateAlertPayment] = useMutation(UPDATE_ALERT_PAYMENT, {
    onCompleted: ({ updateAlertPayment }) => {
      // console.log("updateAlertPayment :", updateAlertPayment);
      setLoading(false);
      if (updateAlertPayment?.isSuccess === true) {
        setAlert(true, "success", updateAlertPayment?.message);
        refetch();
      } else {
        setAlert(true, "error", updateAlertPayment?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("Error", error?.message);
    },
  });

  const handleVoid = () => {
    voidPayment({
      variables: {
        id: paymentId,
      },
    });
  };

  const handleSubmit = () => {
    setLoading(true);
    const createData = alertItemData?.map((e) => ({
      _id: "",
      invoiceId: editData?._id,
      paidAmount: 0,
      alertDate: moment(e?.alertDate).format("YYYY-MM-DD"),
      status: "",
    }));

    const updateData = alertItemData?.map((e) => ({
      _id: e?._id ? e?._id : "",
      invoiceId: editData?._id,
      paidAmount: 0,
      alertDate: moment(e?.alertDate).format("YYYY-MM-DD"),
      status: "",
    }));

    if (alertData?.length === 0) {
      updateAlertPayment({
        variables: {
          input: createData,
        },
      });
    } else {
      updateAlertPayment({
        variables: {
          input: updateData,
        },
      });
    }
  };

  useEffect(() => {
    if (alertData?.length > 0) {
      const data = alertData?.map((e) => ({
        _id: e?._id,
        invoiceId: e?.invoiceId,
        paidAmount: 0,
        alertDate: e?.alertDate,
        status: "",
      }));
      setAlertItemData(data || []);
    } else {
      setAlertItemData([]);
    }
  }, [alertData?.length]);

  // console.log("editData::", editData);
  return (
    <Dialog fullWidth open={open} className="dialog-container" maxWidth="xl">
      <DialogTitleComp
        title={t("modal_title_view_invoice")}
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab
                  sx={{ fontWeight: "bold" }}
                  className={t("class-name-field-title")}
                  label={t("page_invoice")}
                  value="invoice"
                />
                <Tab
                  sx={{ fontWeight: "bold" }}
                  className={t("class-name-field-title")}
                  label={t("alert_payment")}
                  value="alertPayment"
                />
                <Tab
                  sx={{ fontWeight: "bold" }}
                  className={t("class-name-field-title")}
                  label={t("payment")}
                  value="payment"
                />
              </TabList>
            </Box>
            {/* Tabs Invoice ==================================================================== */}
            <TabPanel value="invoice">
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={3}>
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_invoice_id")}
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                  >
                    <Typography
                      className={t("class-name-field-title")}
                      sx={{ fontWeight: "bold" }}
                    >
                      {generateInvoiceNumber(editData?.invoiceNumber)}
                    </Typography>
                  </Box>
                </Grid>

                {/* <Grid item xs={3}>
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_invoice_type")}
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                  >
                    <Typography>{editData?.studentId?.familyName}</Typography>
                  </Box>
                </Grid> */}

                <Grid item xs={3}>
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_student")}
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                  >
                    <Typography>{`${editData?.studentId?.familyName} ${editData?.studentId?.studentName}`}</Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_class")}
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                  >
                    {editData?.enrollmentId && (
                      <Typography>
                        {`${
                          language === "en"
                            ? editData?.enrollmentId?.classId?.courseId?.enName
                            : editData?.enrollmentId?.classId?.courseId?.khName
                        } ${editData?.enrollmentId?.classId?.className}`}
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <ViewItemList listItemData={editData?.items} />
                </Grid>

                <Grid item xs={9}></Grid>

                <Grid item xs={3}>
                  <Stack
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Typography className={t("class-name-field-title")}>
                      {t("thead_total_amount")} :
                    </Typography>
                    <Typography
                      className={t("class-name-field-title")}
                      sx={{ fontWeight: "bold" }}
                    >
                      $ {currencyFormat(editData?.totalAmount)}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Stack
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Typography className={t("class-name-field-title")}>
                      {t("thead_payment_amount")} :
                    </Typography>
                    <Typography
                      className={t("class-name-field-title")}
                      sx={{ fontWeight: "bold", color: "green !important" }}
                    >
                      ${" "}
                      {currencyFormat(
                        editData?.totalAmount - editData?.totalOwe
                      )}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Stack
                    sx={{
                      width: "100%",
                      height: "40px",
                      bgcolor: "#F2F2F2",
                      padding: "8.5px 14px",
                      borderRadius: 1,
                    }}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Typography className={t("class-name-field-title")}>
                      {t("thead_owe_amount")} :
                    </Typography>
                    <Typography
                      className={t("class-name-field-title")}
                      sx={{ fontWeight: "bold", color: "red !important" }}
                    >
                      $ {currencyFormat(editData?.totalOwe)}
                    </Typography>
                  </Stack>
                </Grid>

                {editData?.remark && (
                  <Grid item xs={12} md={12}>
                    <Typography className={t("class-name-field-title")}>
                      {t("thead_remark")}
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        height: "63px",
                        bgcolor: "#F2F2F2",
                        padding: "8.5px 14px",
                        borderRadius: 1,
                      }}
                    >
                      <Typography className={t("class-name-field-title")}>
                        {editData?.remark}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </TabPanel>

            {/* Tabs Alert Invoice ==================================================================== */}
            <TabPanel value="alertPayment">
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={12}>
                  <AlertList
                    listItemData={alertItemData}
                    setListItemData={setAlertItemData}
                  />
                </Grid>

                <Grid item xs={3}>
                  {loading ? (
                    <Button className={t("class-btn-create")} fullWidth>
                      {t("loading")}
                    </Button>
                  ) : (
                    <Button
                      fullWidth
                      onClick={handleSubmit}
                      className={t("class-btn-create")}
                    >
                      {alertData?.length > 0 ? t("update") : t("create")}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </TabPanel>

            {/* Tabs Payment ==================================================================== */}
            <TabPanel value="payment">
              {openVoid && (
                <VoidPayment
                  open={openVoid}
                  loading={loading}
                  handleClose={handleCloseVoid}
                  handleDelete={handleVoid}
                />
              )}
              <TableContainer sx={{ maxWidth: `${width}px` }}>
                <Table className="table" aria-label="simple table">
                  <TableHead className="header-row">
                    <TableRow>
                      <TableCell
                        className={t("class-name-header-title-start")}
                        width="10%"
                      >
                        {t("no")}
                      </TableCell>

                      <TableCell
                        className={t("class-name-header-title")}
                        width="20%"
                      >
                        {t("thead_date")}
                      </TableCell>

                      <TableCell
                        className={t("class-name-header-title")}
                        width="20%"
                        align="right"
                      >
                        {t("thead_payment_amount")}
                      </TableCell>

                      <TableCell
                        className={t("class-name-header-title")}
                        width="40%"
                      >
                        {t("thead_remark")}
                      </TableCell>

                      <TableCell
                        className={t("class-name-header-title-end")}
                        width="10%"
                      ></TableCell>
                    </TableRow>
                  </TableHead>

                  {editData?.paymentHistory?.length === 0 ||
                  editData?.paymentHistory?.length === undefined ? (
                    <TableBody className="body">
                      <TableRow className="body-row">
                        <TableCell colSpan={10} className="body-cell">
                          <EmptyData />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <>
                      <TableBody className="body">
                        {editData?.paymentHistory?.map((row, index) => {
                          // console.log("row::", row);
                          return (
                            <TableRow className="body-row" key={index}>
                              <TableCell
                                className={
                                  row?.void
                                    ? "body-cell-start-void"
                                    : "body-cell-start"
                                }
                              >
                                {index + 1}
                              </TableCell>
                              <TableCell
                                className={
                                  row?.void ? "body-cell-void" : "body-cell"
                                }
                              >
                                {moment(row?.date).format("DD-MMM-YYYY")}
                              </TableCell>
                              <TableCell
                                className={
                                  row?.void ? "body-cell-void" : "body-cell"
                                }
                                align="right"
                                sx={{ color: "#131870" }}
                              >
                                $ {currencyFormat(row?.paidAmount || 0)}
                              </TableCell>
                              <TableCell
                                className={
                                  row?.void ? "body-cell-void" : "body-cell"
                                }
                              >
                                {row?.remark}
                              </TableCell>
                              <TableCell
                                className={
                                  row?.void
                                    ? "body-cell-end-void"
                                    : "body-cell-end"
                                }
                                align="right"
                              >
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="right"
                                >
                                  {!row?.void && (
                                    <Tooltip title={t("void")} placement="top">
                                      <IconButton
                                        onClick={() => handleOpenVoid(row?._id)}
                                      >
                                        <Box className="void-container">
                                          <BlockOutlinedIcon className="void-icon" />
                                        </Box>
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Stack>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </>
                  )}
                </Table>
              </TableContainer>
            </TabPanel>
          </TabContext>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
